import { useEffect, useState } from "react";
import { ANNOUNCEMENTS } from "../config/site";
import { api } from "../lib/api";
import { Marquee } from "./Marquee";

export function AnnouncementBar() {
  const [items, setItems] = useState(ANNOUNCEMENTS);

  useEffect(() => {
    api.announcements()
      .then((list) => { if (list?.length) setItems(list); })
      .catch(() => {});
  }, []);

  return (
    <div
      data-testid="announcement-bar"
      className="bg-brand-forest text-brand-cream/90 py-2 text-[11px] font-display font-medium uppercase tracking-[0.22em]"
    >
      <Marquee items={items} itemClassName="text-brand-cream/90" separator="✦" />
    </div>
  );
}
